import { Logo } from '@/components/brand/logo'
import { Icon } from '@/components/icons/icon'
import { ThemeToggle } from '@/components/theme/theme-toggle'
import { cn } from '@/lib/utils'
import type { TrialState } from './frame'

/** "Trial: 14 days" before the trial starts, "Trial: 9 days left" once it runs (`.ob-trial`). */
export function TrialChip({ days, running }: TrialState) {
  return (
    <span className="ob-trial">
      <Icon name="clock" width={14} height={14} />
      Trial: <b>{days === 1 ? '1 day' : `${days} days`}</b>
      {running ? ' left' : null}
    </span>
  )
}

interface OnboardingTopBarProps {
  trial?: TrialState | null
  /** Shows "Save and exit". */
  onSaveExit?: () => void
  saving?: boolean
}

/** The wizard's sticky header (`.ob-top`): the wordmark, the trial chip, "Save and exit", the theme. */
export function OnboardingTopBar({ trial, onSaveExit, saving = false }: OnboardingTopBarProps) {
  return (
    <header className="ob-top">
      <div className="ob-in">
        <Logo className="h-8" />
        <span className="ob-sp" />
        {trial ? <TrialChip {...trial} /> : null}
        {onSaveExit ? (
          <button
            className={cn('ob-btn ob-btn-q', saving && 'ob-busy')}
            type="button"
            aria-busy={saving || undefined}
            onClick={onSaveExit}
          >
            {saving ? <span className="ob-spin" aria-hidden="true" /> : null}
            {saving ? 'Saving…' : 'Save and exit'}
          </button>
        ) : null}
        <ThemeToggle />
      </div>
    </header>
  )
}
